import React from 'react';

const ChevronRightChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2 17l5-5-5-5-1.4 1.4 3.6 3.6-3.6 3.6z"
        />
    </svg>
);

ChevronRightChunkySvg.displayName = 'ChevronRightChunkySvg';
export default ChevronRightChunkySvg;
